var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPausePartical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.25H1C0.867392 0.25 0.740215 0.302679 0.646447 0.396447C0.552679 0.490215 0.5 0.617392 0.5 0.75V5.75C0.5 5.88261 0.552679 6.00979 0.646447 6.10355C0.740215 6.19732 0.867392 6.25 1 6.25H1.5C1.63261 6.25 1.75979 6.19732 1.85355 6.10355C1.94732 6.00979 2 5.88261 2 5.75V0.75C2 0.617392 1.94732 0.490215 1.85355 0.396447C1.75979 0.302679 1.63261 0.25 1.5 0.25ZM4.75 0.25H4.25C4.11739 0.25 3.99021 0.302679 3.89645 0.396447C3.80268 0.490215 3.75 0.617392 3.75 0.75V5.75C3.75 5.88261 3.80268 6.00979 3.89645 6.10355C3.99021 6.19732 4.11739 6.25 4.25 6.25H4.75C4.88261 6.25 5.00979 6.19732 5.10355 6.10355C5.19732 6.00979 5.25 5.88261 5.25 5.75V0.75C5.25 0.617392 5.19732 0.490215 5.10355 0.396447C5.00979 0.302679 4.88261 0.25 4.75 0.25Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausePartical);
export default __webpack_public_path__ + "static/media/pausePartical.537f0d5776f0085b77605b1c05c5b433.svg";
export { ForwardRef as ReactComponent };